export const getAdditionalFields = (
  challengeToRender: any,
  isRacingGame: boolean
) => {
  // Variables
  //// Record or accumulative
  const type = challengeToRender?.challengeData.pointCountingType;
  //// Map related
  const mapModes =
    challengeToRender?.challengeData.challengeAdditionalData?.mapModes;
  const mapPool =
    challengeToRender?.challengeData.challengeAdditionalData.mapPool;
  const mapNames =
    challengeToRender?.challengeData.challengeAdditionalData?.mapNames;

  return [
    // Team size
    {
      title: "Team size",
      value: challengeToRender?.challengeData.teamSize ?? "Not specified",
      toolTipKey: "Team size",
    },
    // Record or accumulative
    {
      title: "challenge",
      value: type
        ? type === "Cumulative"
          ? "Accumulative"
          : type
        : "Not specified",
      toolTipKey: "Challenge type",
    },
    // Map pool
    {
      title: mapPool ? "Map pool" : `${isRacingGame ? "Tracks" : "Maps"}`,
      value: mapNames
        ? mapPool
          ? mapPool
          : mapNames.join(", ") || "All"
        : "All",
      toolTipKey: "maps",
    },
    // Modes
    {
      title: "Game modes",
      value: mapModes ? mapModes.join(", ") : "All",
      toolTipKey: "modes",
    },
  ];
};
